"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = theme => ({
    root: {
        color: theme.indigo3,
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'currentColor',
            opacity: 0.6
        }
    },
    icon: {
        flexShrink: 0,
        width: '70%',
        height: 'auto',
        maxWidth: 32,
        position: 'relative',
        color: theme.white1
    }
});
//# sourceMappingURL=avatar.overlay.style.js.map